/**
 * 页面路由，路由是浏览器端和服务器端共用的部分
 */
import { routeWarpper } from 'services/page-model';
import About from './cmps/about';
import Jobs from './containers/listPage';
import Home from './cmps/home';
import Contact from './cmps/contact';

export default routeWarpper([
    {
        path: '/pages/:domain/jobs/',
        component: Jobs
    }, {
        path: '/pages/:domain/Contact/',
        component: Contact
    }, {
        path: '/pages/:domain/about/',
        component: About
    }, {
        path: '/pages/:domain/',
        component: Home
    }
]);




// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/routes.js